import * as React from "react";

const LinkRightInactive: React.FC = () => (
    <svg
        width="16px"
        height="16px"
        viewBox="0 0 16 16"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            fill="currentColor"
            d="M14.9999995,7.99999976 C14.9999995,10.5008593 13.6658077,12.8117485 11.4999995,14.0621777 C9.33419228,15.3126078 6.66580772,15.3126078 4.49999952,14.0621777 C2.33419228,12.8117485 0.999999523,10.5008593 0.999999523,7.99999976 C0.999999523,5.49914074 2.33419228,3.1882515 4.49999952,1.93782234 C6.66580772,0.687392235 9.33419228,0.687392235 11.4999995,1.93782234 C13.6658077,3.1882515 14.9999995,5.49914074 14.9999995,7.99999976 Z M0,8 C0,10.8581247 1.52479124,13.4991407 4,14.9282036 C6.47520876,16.3572655 9.52479172,16.3572655 12,14.9282036 C14.4752083,13.4991407 16,10.8581247 16,8 C16,5.14187527 14.4752083,2.50085926 12,1.07179642 C9.52479172,-0.357265472 6.47520876,-0.357265472 4,1.07179642 C1.52479124,2.50085926 0,5.14187527 0,8 Z M10.8531246,8.35312462 L11.2062502,8 L10.8531256,7.6468749 L7.35312557,4.14687538 L7,3.79374981 L6.29374981,4.5 L6.6468749,4.85312462 L9.79374981,8 L6.6468749,11.1468754 L6.29374981,11.5 L7,12.2062502 L7.3531251,11.8531256 L10.8531246,8.35312557 L10.8531246,8.35312462 Z"
            opacity=".5"
        />
    </svg>
);

export default React.memo(LinkRightInactive);
